import React from "react";

const FeatureCheckbox = ({ checked, onChange, disabled = false }) => (
  <label className="inline-flex items-center gap-2 cursor-pointer select-none text-gray-700">
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className="w-4 h-4 accent-[#FE7B38] cursor-pointer"
    />
    <span className="font-medium">Add to Feature</span>
  </label>
);

export default FeatureCheckbox;
